import { setStatic, setDisplayName, defaultProps } from '../utils';
import Drawer from './Drawer';
import ModalBody from '../Modal/ModalBody';
import ModalHeader from '../Modal/ModalHeader';
import ModalTitle from '../Modal/ModalTitle';
import ModalFooter from '../Modal/ModalFooter';
var EnhancedBody = defaultProps({
  classPrefix: 'drawer-body'
})(ModalBody);
setStatic('Body', setDisplayName('Body')(EnhancedBody))(Drawer);
setStatic('Header', defaultProps({
  classPrefix: 'drawer-header'
})(ModalHeader))(Drawer);
setStatic('Title', defaultProps({
  classPrefix: 'drawer-title'
})(ModalTitle))(Drawer);
setStatic('Footer', defaultProps({
  classPrefix: 'drawer-footer'
})(ModalFooter))(Drawer);
export default Drawer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/Drawer/index.js
// module id = 2244
// module chunks = 33